module.exports = __webpack_public_path__ + "img/amazon.7beca6b4.png";